"use client";

import { ErrorComponent } from "@payping/web-components";
import { StatusCodeEnum } from "../types";
import { useAppTranslation } from "../utils/useAppTranslation";

export default function NotFound() {
  const { t } = useAppTranslation();

  return <ErrorComponent statusCode={StatusCodeEnum.NOT_FOUND} error={t("common.errors.userNotFound")} />;
}
